// extracted by mini-css-extract-plugin
export default {"container":"AutoSavedIndicator_container__96t0Y","text":"AutoSavedIndicator_text__th+az"};